import React, { Component, Fragment } from 'react';
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
//import { render } from 'react-dom';
import ReactDatatable from '@ashvin27/react-datatable';
import { toastr } from "react-redux-toastr"
import { Modal } from "react-bootstrap";

//import { CircularProgressbar } from 'react-circular-progressbar';

import minhaImagemTodos from "../../../../src/figuras/exportar-todos.png";
import minhaImagemSelc from "../../../../src/figuras/exportar-selecinados.png";

import Spinner from 'react-bootstrap/Spinner';

import {
    getData, enviaRegistros, getDataTdsRevendas
    // Inicia state Modal
    , getDataTodosUsuarioslogStock
    , GetLogs
    // Fim state Modal
} from "./stockActions"
import { logout } from "./../../../auth/authActions"


// Inicia state Modal
const cstTipoEnvio = [
    { Codigo: "A", Descricao: "Automático" },
    { Codigo: "M", Descricao: "Manual" },
];
const cstProcedimento = [
    { Codigo: 1, Descricao: "Pendentes" },
    { Codigo: 2, Descricao: "Processados" },
];
const cstCodRetorno = [
    { Codigo: -1, Descricao: "Com Erros" },
    { Codigo: 200, Descricao: "Sem erros" },
];
// Fim state Modal

class Stock extends Component {
    constructor(props) {
        super(props)

        this.state = {
            arrayMarcados: []
            , arrayEnviar: []
            , todosArrayEnviar: []
            , SelPuxada: 0
            , booLerRecords: (this.props.codPuxada !== undefined && this.props.codPuxada !== null ? true : false)

            // Inicia state Modal
            , isModalOpen: 0
            , usaDataIntervalo: "on"

            , dataIni: this.formatDateNormal(new Date(Date.now()), 'pt-br')
            , dataFim: this.formatDateNormal(new Date(Date.now()), 'pt-br')

            , Selusulogin: ""
            , SelTipoEnvio: ""
            , SelProcedimento: "0"
            , SelPayload: "0"
            , LimpaRegReposta: false
            , chkGrid: false
            , MsgModal2: ""
            // Fim state Modal
        }

        if (this.props.codPuxada !== undefined && this.props.codPuxada !== null) {
            this.props.getData(this.props.codPuxada);

        }
        else {
            this.props.getDataTdsRevendas();

        }

        this.columns = [

            {
                key: "action1",
                text: "",
                className: "action1",
                width: 30,
                align: "center",
                sortable: false,

                cell: (record, index) => {
                    return (
                        <Fragment>
                            <input
                                name="isGoing"
                                type="checkbox"
                                onClick={this.selecionaCheck.bind(this, record, index)}
                            //    checked={this.state.chkGrid}
                            >
                            </input >
                        </Fragment>
                    );
                }
            },

            {
                key: "resellerID",
                text: "ResellerID",
                className: "resellerID",
                align: "left",
                sortable: true,
            },
            {
                key: "codCatIte",
                text: "CodCatIte",
                className: "codCatIte",
                align: "left",
                sortable: true
            },
            {
                key: "productCode",
                text: "ProductCode",
                className: "productCode",
                align: "left",
                sortable: true
            },
            {
                key: "warehouseName",
                text: "WarehouseName",
                className: "warehouseName",
                align: "left",
                sortable: true
            },
            {
                key: "stockIndicator",
                text: "StockIndicator",
                className: "stockIndicator",
                sortable: true,
                align: "center"
            },
            {
                key: "stockQuantity",
                text: "StockQuantity",
                className: "stockQuantity",
                sortable: true,
                align: "right"
            },
            {
                key: "skuOrderLimit",
                text: "SkuOrderLimit",
                className: "skuOrderLimit",
                sortable: true,
                align: "right"
            },
            {
                key: "createdAtStaging",
                text: "CreatedAtStaging",
                className: "createdAtStaging",
                sortable: true,
                align: "left",
            },
            {
                key: "updatedAtStaging",
                text: "UpdatedAtStaging",
                className: "updatedAtStaging",
                sortable: true,
                align: "left",
            },
            {
                key: "sendToHybrisStatus",
                text: "SndToHyStt",
                className: "sendToHybrisStatus",
                sortable: true,
                align: "left",
            },
            {
                key: "sendToHybrisAt",
                text: "SendToHybrisAt",
                className: "sendToHybrisAt",
                sortable: true,
                align: "left",
            },

        ];
        this.config = {
            key_column: 'productCode',
            page_size: 10,
            length_menu: [10, 20, 50],
            button: {
                excel: true,
                print: true,
                extra: true,
            },
            filename: "Stock",

            language: {
                length_menu: "Mostrar _MENU_ registros por página",
                filter: "Buscar em registros ...",
                info: "Mostrando _START_ a _END_ de _TOTAL_ entradas",
                pagination: {
                    first: "Primeira",
                    previous: "Anterior",
                    next: "Próxima",
                    last: "Última"
                },
                loading_text: "Aguarde buscando informações..."
                , loading: "True"

            }

        }
        this.extraButtons = [
            {
                className: "btn btn-success  ",
                title: "Exporta Selecionados",
                children: [
                    <img src={minhaImagemSelc} alt="" ></img>
                ],
                onClick: () => { this.ExportaSelecao(); },
            },
            {
                className: "btn btn-success ",
                title: "Exporta Todos",
                children: [
                    <img src={minhaImagemTodos} alt="" ></img>
                ],
                onClick: () => { this.ExportaTodos(); },
            },
        ]

        this.ExportaSelecao = this.ExportaSelecao.bind(this);
        this.ExportaTodos = this.ExportaTodos.bind(this);
        this.PopulartodosArrayEnviar = this.PopulartodosArrayEnviar.bind(this)
        this.setbscInf = this.setbscInf.bind(this);
        this.setPuxada = this.setPuxada.bind(this);
        this.setPosSol = this.setPosSol.bind(this);
        this.OpenModalParam = this.OpenModalParam.bind(this);
        this.FecharModalParam = this.FecharModalParam.bind(this);

        // Inicia state Modal

        // this.setCheckUsaData = this.setCheckUsaData.bind(this);
        this.setDataIni = this.setDataIni.bind(this);
        this.setDataFim = this.setDataFim.bind(this);
        this.setBscLogs = this.setBscLogs.bind(this);

        this.setusulogin = this.setusulogin.bind(this);
        this.setTipoEnvio = this.setTipoEnvio.bind(this);
        this.setProcedimento = this.setProcedimento.bind(this);
        this.setRetPayload = this.setRetPayload.bind(this);
        this.ExportarArq = this.ExportarArq.bind(this);
        this.formatDateNormal = this.formatDateNormal.bind(this);
        
        
        // this.mostradado = this.mostradado.bind(this);
        //this.mudachk = this.mudachk.bind(this);
        // Fim state Modal
    }

    // mudachk() {
     //     this.setState({
    //         chkGrid: (this.state.chkGrid === false ? true : false)
    //     });
    // }
    setPuxada(e) {
        this.setState({
            SelPuxada: (e.target.value === "" ? 0 : e.target.value)
           ,booLerRecords: false
        });
    }

    setbscInf() {
        if (this.state.SelPuxada === null || Number(this.state.SelPuxada) === 0 || this.state.SelPuxada === undefined) {
            toastr.warning("Atenção Selecione uma Revenda")
        }
        else {

            this.setState({
                MsgModal2: "Processando solicitação..."
            });
            this.openModal(2)
            this.props.getData(this.state.SelPuxada);
            setTimeout(() => {
                this.setState({
                    booLerRecords: true
                    , isModalOpen: 0
                });
            }, 500);
            // this.setState({
            //     booLerRecords: true
            // });
        }
    }

    // Ini Modal

    setPosSol() {
        this.OpenModalParam(1);
    }

    openModal = (qualfiltro) => {
        this.setState({ isModalOpen: qualfiltro });
    }

    closeModal = () => this.setState({ isModalOpen: 0, LimpaRegReposta: true })

    OpenModalParam(qualfiltro) {

        if (this.props.codPuxada === undefined || this.props.codPuxada === null) {
            if (this.state.SelPuxada === 0 | this.state.SelPuxada === undefined) {
                toastr.warning("Atenção não selecionou uma Revenda !!!")
            }
            else {
                if (qualfiltro === 1) {
                    if (this.props.TipoLicenca === 1 || this.props.TipoLicenca === 2) {
                        this.props.getDataTodosUsuarioslogStock((this.props.codPuxada === undefined || this.props.codPuxada === null
                            ? this.state.SelPuxada : this.props.codPuxada));
                    }
                }
                this.openModal(qualfiltro);
            }
        }
        else {
            if (qualfiltro === 1) {
                if (this.props.TipoLicenca === 1 || this.props.TipoLicenca === 2) {
                    this.props.getDataTodosUsuarioslogStock((this.props.codPuxada === undefined || this.props.codPuxada === null
                        ? this.state.SelPuxada : this.props.codPuxada));
                }
                this.openModal(qualfiltro);
            };
        }
    }

    FecharModalParam() {
        this.setState({
            // usaDataIntervalo: (this.state.usaDataIntervalo === "on" ? "off" : "on"),
            // dataIni: ""
            //, dataFim: "",
            Selusulogin: ""
            , SelTipoEnvio: ""
            , SelProcedimento: "0"
            , SelPayload: "0"
        });

        this.closeModal();
    }

    // setCheckUsaData(e) {

    //     this.setState({
    //         usaDataIntervalo: (this.state.usaDataIntervalo === "on" ? "off" : "on")
    //         // e.target.value
    //     });
    // }
    setDataIni(e) {
        this.setState({
            dataIni: e.target.value
        });
    }
    setDataFim(e) {
        this.setState({
            dataFim: e.target.value
        });
    }

    formatDateNormal(datatrab, formato) {

        if (datatrab !== null) {
            if (formato === 'pt-br') {
                return String(
                    datatrab.getFullYear()
                    + '-'
                    + (datatrab.getMonth() + 1 > 9 ? datatrab.getMonth() + 1 : '0' + (datatrab.getMonth() + 1))
                    + '-'
                    + (datatrab.getDate() > 9 ? datatrab.getDate() : '0' + (datatrab.getDate()))
                )
                //return (datastr.substr(0, 10));
            }
        }
    }
      
    setBscLogs() {
        let booPodeTrazer = true;
        toastr.warning("Buscando informações...");
        if (this.state.usaDataIntervalo === "on") {
            if (this.state.dataIni === "") {
                toastr.warning("Intervalo Data Marcada data inicial não selecionada");
                booPodeTrazer = false;
            }
            if (this.state.dataFim === "" && booPodeTrazer === true) {
                toastr.warning("Intervalo Data Marcada data final não selecionada");
                booPodeTrazer = false;
            }
            if ((this.state.dataIni < "2022-01-01" || this.state.dataFim > "2099-01-01") && booPodeTrazer === true) {
                toastr.warning("Atenção Data inicial ou Data Final Inválida");
                booPodeTrazer = false;
            }
            if (this.state.dataFim < this.state.dataIni && booPodeTrazer === true) {
                toastr.warning("Atenção Data Final menor que o Data Inicial");
                booPodeTrazer = false;
            }
        }
        if (booPodeTrazer === true) {

            //// CUIDADO AO FAZER POR CAUSA DO OPEN MODAL

            // this.setState({
            //     MsgModal2: "Buscando Informações..."
            // });
            // this.openModal(2)
           

                 
            this.props.GetLogs(
                (this.props.codPuxada === undefined || this.props.codPuxada === null
                    ? this.state.SelPuxada : this.props.codPuxada) //CodPuxada
                , (this.state.usaDataIntervalo === "on" ? true : false)   //BooUsaData
                , this.state.dataIni            //DatIni
                , this.state.dataFim            //DatFim
                , (this.props.TipoLicenca === 3 ? this.props.nomeUsuario :
                    (this.state.Selusulogin === "" ? null : this.state.Selusulogin))
                //StrUsu
                , (this.state.SelTipoEnvio === "" ? null : this.state.SelTipoEnvio)      //Tipo_Envio
                , this.state.SelProcedimento    //IntCodRetorno
                , this.state.SelPayload         //IntPend_Proc
                                    ,);
            // setTimeout(() => {
            this.setState({
                LimpaRegReposta: false
                // , isModalOpen: 0
            });
            // }, 500);


        }

    }

    setusulogin(e) {
        this.setState({
            Selusulogin: e.target.value
        });
    }
    setTipoEnvio(e) {
        this.setState({
            SelTipoEnvio: e.target.value
        });
    }
    setProcedimento(e) {
        this.setState({
            SelProcedimento: e.target.value
            , SelPayload: (e.target.value === "1" ? "0" : this.state.SelPayload)
        });
    }
    setRetPayload(e) {
        this.setState({
            SelPayload: e.target.value
        });
    }
    ExportarArq(codCatIte, dat_status_stock, usr_envio, arquivo) {

        let downloadLink, dataType = 'application/vnd.ms-excel';

        let tableHtml = arquivo;

        // Specify file name
        let filename = "Arq_" + codCatIte + "_" + dat_status_stock + "_" + usr_envio + ".xml";
        // Create download link element
        downloadLink = document.createElement("a");
        if (navigator.msSaveOrOpenBlob) {
            let blob = new Blob(['\ufeff', tableHtml], {
                type: dataType
            });
            navigator.msSaveOrOpenBlob(blob, filename);
        } else {
            // Create a link to the file
            downloadLink.href = 'data:' + dataType + ', ' + tableHtml;
            // Setting the file name
            downloadLink.download = filename;
            //triggering the function
            downloadLink.click();
        }

    }

    //Fim Modal

    PopulartodosArrayEnviar() {

        this.setState({
            todosArrayEnviar: []
        });

        if (this.props.redListaStock !== undefined && this.props.redListaStock !== null) {
            for (let i = 0, l = this.props.redListaStock.length; i < l; i++) {
                this.state.todosArrayEnviar.push(this.props.redListaStock[i].codCatIte);
            }
        }
        // Array nao precisa de setstate
        // this.setState({
        //     todosArrayEnviar: array2
        // });

        // console.log("todosArrayEnviar: " + this.state.todosArrayEnviar)
    }

    selecionaCheck = (registro, record, index) => {

        const array1 = [];
        const array2 = [];
        let Existe = [{}];

        Existe = this.state.arrayMarcados
            .filter((a) => a.codCatIte === registro.codCatIte)

        if (Existe.length === 0) {
            this.state.arrayMarcados.push(registro)
            this.state.arrayEnviar.push(registro.codCatIte);
        }
        else {
            //Carrega Array1
            for (let i = 0, l = this.state.arrayMarcados.length; i < l; i++) {
                if (this.state.arrayMarcados[i].codCatIte !== registro.codCatIte) {
                    array1.push(this.state.arrayMarcados[i]);
                    array2.push(this.state.arrayMarcados[i].codCatIte);
                }
            }

            this.setState({
                arrayEnviar: array2
                , arrayMarcados: array1
            });

        }

    }

    ExportaSelecao() {
        if (this.state.arrayEnviar.length === 0) {
            toastr.warning("Não há seleção realizada !!!!")
        }
        else {
            this.setState({
                MsgModal2: "Enviando a solicitação... Será realizado em fila processamentos"
            });
            this.openModal(2)
            this.props.enviaRegistros(this.state.arrayEnviar
                , (this.props.codPuxada === undefined || this.props.codPuxada === null
                    ? this.state.SelPuxada : this.props.codPuxada)
                , this.props.nomeUsuario)

            setTimeout(() => {
                this.setState({
                    arrayMarcados: []
                    , arrayEnviar: []
                    , isModalOpen: 0
                });

            }, 4000);

            //setTimeout(this.closeModal(), 4000);

        }

    }

    ExportaTodos() {

        this.PopulartodosArrayEnviar();
        let podeenviar = true;

        if (this.state.todosArrayEnviar.length === 0) {
            toastr.warning("Não há produtos a enviar !!!!")
            podeenviar = false
        }
        if (this.props.codPuxada === undefined || this.props.codPuxada === null) {
            if (this.state.SelPuxada === undefined
                || this.state.SelPuxada === null
                || this.state.SelPuxada === 0) {
                toastr.warning("Revenda não selecionada !!!!")
                podeenviar = false;
            }
        }

        if (podeenviar === true) {
            this.setState({
                MsgModal2: "Enviando a solicitação... Será realizado em fila processamentos"
            });
            this.openModal(2)
            this.props.enviaRegistros(this.state.todosArrayEnviar
                , (this.props.codPuxada === undefined || this.props.codPuxada === null
                    ? this.state.SelPuxada : this.props.codPuxada)
                , this.props.nomeUsuario)
            setTimeout(() => {
                this.setState({
                    arrayMarcados: []
                    , arrayEnviar: []
                    , isModalOpen: 0
                });

            }, 5000);
        }
    }

    // editRecord(record) {
    //     console.log("Edit Record", record);
    // }

    // MrcDesRecord(event, record) {
    //     if (event.onChange){
    //         console.log("Edit Record: ", record);
    //         console.log("checked: ", event.onChange);

    //     }
    //     else
    //     {
    //         console.log("Edit Record: ", record);
    //         console.log("deschecked: ", event.onChange);
    //     }
    // }
    // MrcDesRecord = (e, record) => {
    //     console.log("Edit record: " + record);
    //     console.log("Selecao: " + (e.type === 'checkbox' ? e.checked : e.value));
    // }

    // mostradado() {
    //     let texto = "";
    //     for (let i = 0; i < this.state.MsgModal2.length; i++) {
    //         texto += this.state.MsgModal2.substring(i, 1);
    //         setTimeout(texto, 100);
    //         console.log(texto)
    //     }
    // }
    render() {
        const Listapuxadas = this.props.redListaTdsRevendas || [];

        // Inicia state Modal
        const RegResposta = (this.state.LimpaRegReposta === true ? [] : this.props.RedListaBscLogs || [] );
        const ConstBscUsuRev = this.props.BscUsuRev || [];

        // Fim state Modal
        // console.log("this.state.LimpaRegReposta: " + this.state.LimpaRegReposta)
        return (


            <div className="container" >

                <div className="row">
                    <div className="Col">
                        <span className="cadastro-Externos">Inicial / &nbsp;
                            <span className="text-style-1">Stock</span>
                        </span>
                    </div>
                    <br />
                    <br />
                </div>

                <div className="row" style={{
                    display: (this.props.codPuxada === undefined || this.props.codPuxada === null ? "flex" : "none")
                    , fontSize: "18px", color: "#77b935", fontFamily: "Barlow"
                }}>
                    <div className="col">
                        <select id="Revenda"
                            value={this.state.SelPuxada}
                            onChange={this.setPuxada}
                        >
                            <option value="">-- Selecione Revenda --</option>
                            {Listapuxadas
                                .map((ar, i) => (
                                    <option key={i} value={ar.cod_puxada}>
                                        {ar.cod_puxada + " - " + ar.dsc_razaosocial}
                                    </option>
                                ))}
                        </select>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <button type="button"
                            style={{ fontSize: "18px", color: "#77b935" }}

                            data-toggle="tooltip"
                            title="Adiciona a Lista"
                            onClick={this.setbscInf}
                        >
                            <i className="fa fa-refresh " aria-hidden="true"></i>
                        </button>
                    </div>

                    <div className="col">
                        <button type="button"
                            style={{ color: "#77b935", marginLeft: "10px" }}
                            data-toggle="tooltip"
                            title="Posição das Solicitações"
                            onClick={this.setPosSol}
                        >
                            <i className="fa fa-stack-overflow" aria-hidden="true"> </i>

                        </button>
                    </div>

                    <br />
                    <br />
                </div>
                <div className="Puxada"
                    style={{
                        display: (this.props.codPuxada !== undefined && this.props.codPuxada !== null ? "flex" : "none")
                    }}
                >
                    <div className="row">
                        <div className="col"
                            style={{ fontSize: "12px", color: "#77b935" }}>
                            <span className="cadastro-Externos1">&nbsp;
                                <span>Código da Revenda: &nbsp; {(this.props.codPuxada === undefined || this.props.codPuxada === null ? 0 : this.props.codPuxada)}</span>
                            </span>
                        </div>
                        <div className="col">
                            <button type="button"
                                style={{ color: "#77b935", marginLeft: "200px" }}
                                data-toggle="tooltip"
                                title="Posição das Solicitações"
                                onClick={this.setPosSol}
                            >
                                <i className="fa fa-stack-overflow" aria-hidden="true"> </i>

                            </button>
                        </div>
                    </div>
                    <br />
                    <br />
                </div>
                {/* <div>
                    <input
                        name="chk1"
                        type="checkbox"
                        onChange={this.mudachk}
                    >
                    </input >
                </div> */}
                <div>
                    <ReactDatatable
                        config={this.config}
                        records={(this.state.booLerRecords === true ? this.props.redListaStock || [] : [])}
                        columns={this.columns}
                        extraButtons={this.extraButtons}
                    />
                </div>

                {/*Modal leitura*/}
                <Modal size="sm" show={(this.state.isModalOpen === 2 ? true : false)}
                    className="modal fade" role="dialog"
                    onHide={this.closeModal}

                >
                    <Modal.Body >
                        <div className="row d-flex justify-content-center" >
                            <Spinner animation="border" role="status" variant="success">
                            </Spinner>
                        </div>
                        <div className="row" style={{ textAlign: "Center" }}>
                            <i className="fa-blink "> {this.state.MsgModal2}</i>
                            {/* <span> {this.state.MsgModal2} </span> */}

                        </div>
                    </Modal.Body>

                </Modal>

                {/* Posicao das Solicitacoes */}
                <Modal size="xl" show={(this.state.isModalOpen === 1 ? true : false)}
                    className="modal fade" role="dialog"
                    onHide={this.closeModal}
                >
                    <Modal.Header>
                        <Modal.Title
                            style={{
                                color: "#77b935"
                                , fontFamily: "Barlow"
                                , fontSize: "18px"
                                , fontStyle: "Italic"
                            }}
                        >Acompanhamento das Operações Solicitadas
                            <br />
                            Filtros
                        </Modal.Title>
                        <button type="button"
                            style={{ background: "#77b935" }}
                            className="btn btn-secondary"
                            onClick={this.FecharModalParam}
                        >Retorna
                        </button>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form-control ">
                            <div className="input-group input-group-sm mb-1"
                            >
                                {/* <div className="input-group-prepend"> */}
                                <div className="input-group-text" style={{
                                    color: "#77b935"
                                    , fontFamily: "Barlow"
                                    , fontSize: "18px"
                                    , fontStyle: "Italic"
                                }}
                                >Intervalo Data &nbsp;
                                    {/* <input type="checkbox"
                                            checked={(this.state.usaDataIntervalo === "on" ? "on" : "")}
                                            onChange={this.setCheckUsaData} >
                                        </input> */}
                                </div>

                                {/* </div> */}
                                <div style={{
                                    display: (this.state.usaDataIntervalo === "on" ? "flex" : "none")
                                    , color: "#77b935"
                                }}>
                                    &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; Início: &nbsp;&nbsp;
                                    <div className="LancTitDataIni">
                                        <input type="date"
                                            placeholder="dd-MM-yyyy"
                                            id="dataIni"
                                            min="2022-01-01" max="2099-01-01"
                                            value={this.state.dataIni}
                                            // defaultValue={this.formatDateNormal(this.state.dataIni, 'pt-br')}
                                            onChange={this.setDataIni}

                                        />
                                    </div>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Final: &nbsp;&nbsp;
                                    <div className="LancTitDataFim">
                                        <input type="date"
                                            placeholder="dd-MM-yyyy"
                                            id="dataFim"
                                            min="2022-01-01" max="2099-01-01"
                                            value={this.state.dataFim}
                                            //defaultValue={this.formatDateNormal(this.state.dataFim, 'pt-br')}
                                            onChange={this.setDataFim}

                                        />
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="form-control ">
                            {/* Somente Para Usarios Tipo Heineken e Flag */}
                            <select id="Usuario"
                                style={{ display: (this.props.TipoLicenca === 1 || this.props.TipoLicenca === 2 ? "" : "none") }}
                                value={this.state.Selusulogin}
                                onChange={this.setusulogin}
                            >
                                <option value="">-- Selecione Usuário --</option>
                                {ConstBscUsuRev
                                    .map((ar, i) => (
                                        <option key={i} value={ar.usr_envio}>
                                            {ar.usr_envio}
                                        </option>
                                    ))}
                            </select>
                            &nbsp;&nbsp;&nbsp;
                            <select id="TipoEnvio"
                                value={this.state.SelTipoEnvio}
                                onChange={this.setTipoEnvio}
                            >
                                <option value="">-- Selecione Tipo Envio --</option>
                                {cstTipoEnvio
                                    .map((ar, i) => (
                                        <option key={i} value={ar.Codigo}>
                                            {ar.Descricao}
                                        </option>
                                    ))}
                            </select>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <select id="Procedimento"
                                value={this.state.SelProcedimento}
                                onChange={this.setProcedimento}
                            >
                                <option value="0">-- Selecione Procedimento --</option>
                                {cstProcedimento
                                    .map((ar, i) => (
                                        <option key={i} value={ar.Codigo}>
                                            {ar.Codigo + " - " + ar.Descricao}
                                        </option>
                                    ))}
                            </select>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <select id="RetPayload"
                                style={{ display: (this.state.SelProcedimento === "1" ? "none" : "") }}
                                value={(this.state.SelProcedimento === "1" ? "0" : this.state.SelPayload)}
                                onChange={this.setRetPayload}
                            >
                                <option value="0">-- Selecione Retorno Payload --</option>
                                {cstCodRetorno
                                    .map((ar, i) => (
                                        <option key={i} value={ar.Codigo}>
                                            {ar.Codigo + " - " + ar.Descricao}
                                        </option>
                                    ))}
                            </select>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <button type="button"
                                style={{ fontSize: "18px", color: "#36561e" }}
                                data-toggle="tooltip"
                                title="Busca Logs"
                                onClick={this.setBscLogs}
                            >
                                <i className="fa fa-refresh " aria-hidden="true"></i>
                            </button>

                        </div>

                        <div className="form-control">
                            <div className="table "
                                style={{
                                    fontFamily: "Barlow", fontSize: "12px",
                                    color: "#36561e", height: "300px", overflow: "auto"
                                }}>
                                <table className="table table-bordered  table-striped table-sm "
                                >
                                    <thead className="thead">
                                        <tr >
                                            <th style={{ display: (this.props.TipoLicenca === 3 ? "none" : "") }} > </th>
                                            <th>CodCatite</th>
                                            <th>Data Envio</th>
                                            <th>Enviado</th>
                                            <th>Usuário</th>
                                            <th>Tipo</th>
                                            <th>Cod.Ret.</th>
                                            <th>{(this.props.TipoLicenca === 3 ? "" : "Chave_log")}</th>
                                            <th>{(this.props.TipoLicenca === 3 ? "" : "Descrição_xml")}</th>
                                        </tr>
                                    </thead>
                                    <tbody className="tbody">
                                        {(RegResposta.length === 0 ? 
                                            
                                            <span> <br /><br /><br />  &nbsp;&nbsp; &nbsp;&nbsp; "Não há Dados"
                                            </span>
                                        
                                            :
                                            RegResposta.map((item, i) => {
                                                return (
                                                    <tr key={i}>
                                                        <td
                                                            style={{ display: (this.props.TipoLicenca === 3 ? "none" : "") }}
                                                        >
                                                            <span
                                                                type="button"

                                                                onClick={() => { this.ExportarArq(item.codCatIte, item.dat_status_stock.substr(0, 10), item.usr_envio, item.dsc_xml) }}
                                                                title="Exportar XML">
                                                                <i className="fa fa-download" aria-hidden="true"></i>

                                                            </span>

                                                        </td>
                                                        <td>{item.codCatIte}</td>
                                                        <td>{item.dat_status_stock}</td>
                                                        <td>{item.ind_enviado}</td>
                                                        <td>{item.usr_envio}</td>
                                                        <td>{item.tipo_envio}</td>
                                                        <td>{(this.props.TipoLicenca === 3 ? "" : item.chave_log)}</td>
                                                        <td>{(this.props.TipoLicenca === 3 ? "" : item.cod_retorno)}</td>
                                                        <td>{(item.dsc_xml === "" ? "" : item.dsc_xml.substr(0, 100))}</td>

                                                    </tr>
                                                )
                                            })
                                        )
                                        }

                                    </tbody>

                                </table>
                            </div>
                        </div >

                    </Modal.Body>

                    <Modal.Footer>
                    </Modal.Footer>
                </Modal>


            </div >
        )
    }
}
const mapStateToProps = state => (
    {
        nomeUsuario: state.authRed.NomUsuario
        , codPuxada: state.authRed.CodPuxada
        , TipoLicenca: state.authRed.TipoUsuario
        , redListaStock: state.stockReducer.listaStock
        , redListaTdsRevendas: state.stockReducer.ListaTdsRevendas

        // Inicia state Modal
        , RedListaBscLogs: state.stockReducer.ListaBscLogs
        , BscUsuRev: state.stockReducer.ListaTdsUsuariosRev
        // Fim state Modal

    }
)
const mapDispatchToProps = dispatch => bindActionCreators(
    {
        getData
        , enviaRegistros
        , logout
        , getDataTdsRevendas

        // Inicia state Modal
        , getDataTodosUsuarioslogStock
        , GetLogs
        // Fim state Modal
    }
    , dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Stock)